import { useEffect, useState } from "react";

/**
 * True below Tailwind's `md` breakpoint (767px). Drives the copy modules'
 * `pick(node, isMobile)` — the mobile strings ARE the paraphrase, already
 * written and already checked at 320px, so never truncate the desktop one
 * with CSS instead.
 *
 * Lifted out of WorkspaceBanner so the empty-scan panel uses the same
 * breakpoint; two hooks disagreeing by a pixel would swap copy variants
 * mid-resize on one surface and not the other.
 */
export default function useIsMobile() {
  const [m, setM] = useState(
    typeof window !== "undefined" ? window.matchMedia("(max-width: 767px)").matches : false
  );
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(max-width: 767px)");
    const on = (e) => setM(e.matches);
    setM(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return m;
}
